export default {
  categories: {},
  mappings: {},
  hasChanges: false,
  isLoading: true,
  isSubmitting: false,
  etag: null,
  status: null,
};
